import React, {Component} from "react";
import {HashRouter, Route, Switch} from "react-router-dom";
import RouterGuard from "./components/routerGuard/RouterGuard";
import FirebaseAuthProvider from "./components/firebase/FirebaseAuthProvider";

import "./App.css";
// Styles
// CoreUI Icons Set
import "@coreui/icons/css/coreui-icons.min.css";
// Import Flag Icons Set
import "flag-icon-css/css/flag-icon.min.css";
// Import Font Awesome Icons Set
import "@fortawesome/fontawesome-free/scss/fontawesome.scss";
import "@fortawesome/fontawesome-free/scss/regular.scss";
import "@fortawesome/fontawesome-free/scss/solid.scss";
import "@fortawesome/fontawesome-free/scss/brands.scss";
// Import Simple Line Icons Set
import "simple-line-icons/css/simple-line-icons.css";
// Import Main styles for this application
import "./scss/style.css";
// Containers
import {Layout} from "./containers";
// Pages
import {Login, Page404, Register} from "./views/Pages";
import JobWelcomePage from "./views/Settings/Branding/JobWelcomePage";
import {CompanyInformation} from "./views/company-information/company-information";

// import { renderRoutes } from 'react-router-config';

class App extends Component {
	componentDidMount() {
		window.is_safari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
		if (window.is_safari) {
			document.body.classList.add('safari-browser');
		}
	}

	render() {
		return (
			<FirebaseAuthProvider>
				<HashRouter>
					<Switch>
						<Route exact path="/login" name="Login Page" component={Login}/>
						<Route
							exact
							path="/register"
							name="Register Page"
							component={Register}
						/>
						<Route
							exact
							path="/preview"
							name="Preview Job Page"
							component={JobWelcomePage}
						/>
						{/*<Route exact path="/404" name="Page 404" component={Page404} />*/}
						{/*<Route exact path="/500" name="Page 500" component={Page500} />*/}
						<RouterGuard>
							<Route path="/" name="Home" component={Layout}/>
						</RouterGuard>
						<Route component={Page404}/>
					</Switch>
				</HashRouter>
				<CompanyInformation/>
			</FirebaseAuthProvider>
		);
	}
}

export default App;
